import './reports.css'

/**
 * The locked picture (P10): seven stacked stubs and four row stubs, in the real chart's and table's
 * anatomy. No figure, no text, no control: the gate renders this INSTEAD of the children, so a free user
 * is never fetched or shown a real number. The shapes are declared inside the component, not as a
 * module-level map, so nothing about them ships as data.
 */
export function ReportPreview() {
  const heights = [50, 70, 45, 80, 60, 90, 55]
  const rows = [70, 50, 80, 40]
  return (
    <div className="rp-preview" aria-hidden="true">
      <div className="rp-preview__chart">
        {heights.map((h, i) => (
          <span key={i} className="rp-preview__bar" style={{ height: `${h}%` }} />
        ))}
      </div>
      <div className="rp-preview__rows">
        {rows.map((w, i) => (
          <span key={i} className="rp-preview__row" style={{ width: `${w}%` }} />
        ))}
      </div>
    </div>
  )
}
